import script from "./VKAdsStatProcessor.vue?vue&type=script&setup=true&lang=js"
export * from "./VKAdsStatProcessor.vue?vue&type=script&setup=true&lang=js"

import "./VKAdsStatProcessor.vue?vue&type=style&index=0&id=201bfd91&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-201bfd91"]])

export default __exports__